import { messages as ptMessages } from './pt-br';
import { messages as enMessages } from './en-us';

const messages = {
  ...ptMessages,
  ...enMessages
};

export { messages };
